import React from 'react'
import constants from 'utils/constants'

import { FeedGalleryItemBlock, FeedGalleryItemImg } from './style'

const FeedGalleryItem = ({ feedItem }) => {
  const iamgePath = `${constants.imagePath}/task_img/${feedItem.proof[0]}`

  return (
    <FeedGalleryItemBlock>
      <FeedGalleryItemImg src={iamgePath} />
    </FeedGalleryItemBlock>
  )
}

export default FeedGalleryItem
